<template>
  <Modal ref="modalRef" class="profile-rel-owner-modal" info>
    <template #title>{{ spouse ? 'Spouse' : 'Parent' }} relationship</template>
    <div class="help-text">
      The selected {{ spouse ? 'spouse' : 'parent' }} relationship is defined in:
    </div>
    <div class="matches-area">
      <ul class="list-unstyled matches-list">
        <li v-for="id in ownerProfileIds" :key="id">
          <ProfileCard
            :person-id="id"
            show-profile-type
            :this-profile="id == personId">
          </ProfileCard>
        </li>
      </ul>
    </div>
  </Modal>
</template>

<style lang="scss" scoped>
.matches-area {
  margin-top: 1rem;
  margin-left: 1rem;
  padding: 0.5rem 0; // margin-top causes jumping when expanding (??)

  .list-header {
    margin-bottom: 0.5rem;
    font-size: 0.75rem;
    color: #888;
  }

  .matches-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .action-row {
    margin-left: 0;
  }
}
</style>

<script lang="ts" setup>
import { ref } from 'vue'
import { useModalAutoHide } from '@/util/AppUtil'
import Modal from '@/util/Modal.vue'
import ProfileCard from '@/manage/ProfileCard.vue'

const props = defineProps<{
  personId: string
  ownerProfileIds: string[]
  spouse?: boolean
}>()

defineExpose({
  open: () => modalRef.value?.open(),
})

const modalRef = ref<InstanceType<typeof Modal>>()

useModalAutoHide(modalRef)
</script>
